export enum TableColumnDisplayType {
	raw = 'raw',
	contextMenu = 'contextMenu',
	documentContextMenu = 'documentContextMenu',
	checkbox = 'checkbox',
	changeIndicator = 'changeIndicator',
	morningstarRating = 'morningstarRating',
	link = 'link',
	expander = 'expander',
	color = 'color',
	scale = 'scale',
	weightingBar = 'weightingBar',
	icon = 'icon',
	actions = 'actions',
	barScale = 'barScale',
}
